// Unique id (string) generator
function generateUniqueId(prependString = 'a') {
  const S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return `${prependString}${S4()}${S4()}${S4()}`
}

// Simple proprietary id encode to obfuscate some ids when communicating with BE
function encodeId(id) {
  id = id.toString()
  let sum = 0;
  let count = 0;
  for (let i of id) {
    let digit = parseInt(i);
    if (count % 2 == 0) {
      digit = digit * 2;
    }
    if (digit > 9) {
      digit = digit - 9;
    }
    sum = sum + digit;
    count++;
  }
  let validator = (10 - sum%10) % 10;
  return id + validator;
}

export default {
  generate: generateUniqueId,
  encode:   encodeId
}